import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "@/App";
import { Toaster } from "@/components/ui/toaster";
import { SupabaseProvider } from "@/contexts/SupabaseContext";
import "@/index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <SupabaseProvider>
        <App />
        <Toaster />
      </SupabaseProvider>
    </BrowserRouter>
  </React.StrictMode>
);